import React from 'react';
import styles from './SelectField.module.css';

const SelectField = ({ value, onChange, onBlur, options, error, placeholder, required }) => (
    <div className={styles.wrapper}>
        <select
            className={`${styles.selectLayout} ${error ? styles.inputError : ''}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            required={required}
        >
            <option value="">{placeholder}</option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
        <p className={styles.error}>{error}</p>
    </div>
);

export default SelectField;